import React, { useState } from "react";
import { Flex, FormDialog, Typography, Box, Button } from "flux";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import { useDialog } from "@adora/shared/hooks/use-dialog";
import ConfirmationDialog from "@adora/shared/components/confirm-dialog";
import uploadFile from "../../utils/upload-ad-builder-images";

interface BulkUpdateAdBuilderImagesDialogProps extends BaseDialogProps {
  adAssetGroupId: number;
}

const BulkUpdateAdBuilderImagesDialog: React.FC<BulkUpdateAdBuilderImagesDialogProps> = ({
  open,
  onClose,
  adAssetGroupId
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [updating, setUpdating] = useState(false);

  const { openDialog } = useDialog();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setUpdating(true);
    if (file) {
      await uploadFile(file, adAssetGroupId);
      onClose(true);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const fileName = event.target.files[0].name;
      const extension = fileName.split(".").pop()?.toLowerCase();
      if (extension !== "zip") {
        openDialog(ConfirmationDialog, {
          title: "Error",
          description: "File must be a '.zip' file",
          showCancel: false,
          danger: true,
          primaryButtonText: "Ok"
        });
      } else {
        setFile(event.target.files[0]);
      }
    }
  };

  return (
    <FormDialog
      open={open}
      onClose={(e) => {
        if (window.confirm("Are you sure you want to close this dialog?")) {
          onClose(e);
        }
      }}
      title="Upload Edited Ad Images (bulk)"
      primaryButtonText="Update"
      onSubmit={handleSubmit}
      isPrimaryButtonDisabled={updating}
      dataDogIdentifier="upload edited ad images (bulk)"
    >
      <Flex flexDirection="column" gap={2}>
        <Box mb={4}>
          <input type="file" onChange={handleFileChange} style={{ display: "none" }} id="file-upload-input" />
          <label htmlFor="file-upload-input">
            <Button
              variant="contained"
              component="span"
              dataDogIdentifier="upload edited ad images (bulk) upload zip file"
            >
              Upload Zip File
            </Button>
          </label>
          {file && (
            <Typography variant="body2" mt={1}>
              Selected file: {file.name}
            </Typography>
          )}
        </Box>
      </Flex>
    </FormDialog>
  );
};

export { BulkUpdateAdBuilderImagesDialog };
